export default {
  buttons: {
    add: 'Dodaj',
  },
  AddOn: {
    label: 'Dodatek',
    title: 'Zdobądź swoją aplikację mobilną',
    subscribed: 'Wykupiono',
    cta: 'Zdobądź swoją aplikację mobilną',
    price_per_month: '{{price}} / miesiąc',
    tax_included: 'z uwzględnieniem podatku',
    apple_developer_note: 'Wymaga konta Apple Developer (99 USD/rok, płacone Apple) na osobę prawną restauracji.',
    features: {
      stores: 'Dostępna w App Store i Google Play',
      push: 'Powiadomienia push do Twoich gości',
      loyalty: 'Punkty lojalnościowe i nagrody',
      commission: 'Zamówienia bezpośrednie z 0% prowizji',
    },
  },
};
